<template>
  <div class="card card-chat-booking float-left ml-3">
    <div class="card-body">
      <div class="mb-3">
        <b>{{ $t('message.menu.payment_method') }}</b>
      </div>
      <div v-if="bookingData">
        <a href="" class="text-secondary" @click.prevent="sendMessage(0)">
          <div class="card border-secondary">
            <div class="card-body p-3">
              <i class="fal fa-credit-card"></i> {{ $t('message.payment_method.credit_debit_card') }}
            </div>
          </div>
        </a>
        <a href="" class="text-secondary" @click.prevent="sendMessage(1)">
          <div class="card border-secondary">
            <div class="card-body p-3">
              <i class="fal fa-money-bill-wave"></i> {{ $t('message.payment_method.bank_transfer') }}
            </div>
          </div>
        </a>
        <a href="" class="text-secondary" @click.prevent="sendMessage(2)">
          <div class="card border-secondary mb-0">
            <div class="card-body px-3 py-2 text-dark">
              <i class="fal fa-qrcode"></i> {{ $t('message.payment_method.promptpay') }}
              <img src="/static/img/thai_qr_payment.png" height="40" class="rounded ml-2"/>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { checkoutCostMixin } from '../../../mixins/checkoutCostMixin'
  import { mapState } from 'vuex'

  export default {
    mixins: [checkoutCostMixin],
    props: {
      message: Object
    },
    data () {
      return {
        paymentMethods: null
      }
    },
    computed: {
      ...mapState('chatBooking', ['messages', 'bookingData'])
    },
    methods: {
      sendMessage (index) {
        const item = this.paymentMethods[index]
        const message = {
          sender_type: 'user',
          type: 'text',
          label: item.label,
          text: item.text,
          data: item.data
        }
        this.$store.commit('chatBooking/ADD_MESSAGE', message)
      }
    },
    mounted () {
      if (this.bookingData) {
        this.paymentMethods = [
          {
            label: 'credit-card-payment',
            text: 'ชำระเงินผ่านบัตรเครดิต/เดบิต',
            data: `id=${this.bookingData.id}&payment_method=credit_card`
          },
          {
            label: 'bank-transfer-payment',
            text: 'ชำระเงินด้วยวิธีโอนเงิน/Internet Banking',
            data: `id=${this.bookingData.id}&payment_method=bank_transfer`
          },
          {
            label: 'promptpay-payment',
            text: 'ชำระเงินด้วยพร้อมเพย์',
            data: `id=${this.bookingData.id}&payment_method=propmtpay`
          }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/PaymentMethodMessage.vue